// removed by extract-text-webpack-plugin
module.exports = {"box-content":"Tile__box-content__vGYHb","left-box-content":"Tile__left-box-content__MuoUZ","left-baner":"Tile__left-baner__BwJR9","right-baner":"Tile__right-baner__17AHs","box":"Tile__box__EabFT","left-box":"Tile__left-box__A5oGA","header":"Tile__header__3rLRL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExclusiveExperience/Tile/Tile.scss
// module id = 689
// module chunks = 0